
import api from "../../../api/api"


const getProjectList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/project/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const updateDPR= (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("ess/project/dpr",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getLastDPR = () =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/project/dpr/last").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const essProjectServices = {
    getProjectList,
    updateDPR
}
export default essProjectServices;